/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState } from "react";
import {
  Collapse,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import {
  BiChevronDown
} from "react-icons/bi";
import { BsQuestionCircle } from "react-icons/bs";
import { FcFinePrint } from "react-icons/fc";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ConfirmationModal from "../../../../components/ConfirmationModal/ConfirmationModal";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import DsBreadcrumbs from "../DsBreacdcrumbs/DsBreadcrumbs";
import LinkDataItems from "../LinkDataItems/LinkDataItems";


const LinkDataSource = ({
  t,
  regulation,
  paramId,
  dsId = "",
  handleDataSourceCallback,
  configType,
  paramType
}) => {
  const [regulationId, setRegulationId] = useState(regulation);
  const [parentId, setParentId] = useState("");
  const [dsList, setDsList] = useState([]);
  const [selDataSource, setSelDataSource] = useState(dsId ? dsId : "");
  const [rootList, setRootList] = useState([]);
  const [shown, setShown] = useState(false);
  const [currentDs, setCurrentDs] = useState([]);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [messageConfirmation, setMessageConfirmation] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    getDataSourceByRegulation();
  }, []);

  const closeLinkDataSource = (e) => {
    e.preventDefault();
    handleDataSourceCallback(false);
  };

  const getDataSourceByRegulation = (parentId = "", name = "") => {
    RiskConfigService.getDataSourceByRegulation(regulationId, parentId, configType, 
      paramType !== 'metric-question' && paramType !== 'gd-question')
      .then((response) => {
        if (response.data.length > 0) {
          if (parentId) {
            setDsList([...response.data]);
            const found = currentDs.some((el) => el.id === parentId);
            if (!found) {
              let obj = { id: parentId, name: name };
              setCurrentDs([...currentDs, obj]);
            }
          } else {
            setRootList([...response.data]);
          }
        } else {
          if (parentId && currentDs.length > 1) {
            setIsConfirmation(true);
            setMessageConfirmation("No records available");
          }

        }
      })
      .catch((error) => {
      });
  };

  const changeDatasource = (e) => {
    e.preventDefault();
    let opt = e.target.value;
    getDataSourceByRegulation(opt);
  };

  const handleExpandDs = (e, id, name) => {
    setDsList([]);
    setCurrentDs([]);

    const newVal = !shown[id];
    if (newVal) {
      getDataSourceByRegulation(id, name);
      let obj = { id: id, name: name };
      setCurrentDs([...currentDs, obj]);
    }
    setShown({
      [id]: !shown[id],
    });
  };

  const saveDataSourceByRegulation = (dsId) => {
    RiskConfigService.saveDataSourceByRegulation(regulationId, paramId, dsId, paramType)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          handleDataSourceCallback(true);
        }
      })
      .catch((error) => {
      });
  };

  const saveDataSource = () => {
    if (selDataSource) {
      saveDataSourceByRegulation(selDataSource);
    } else {
      setMessageConfirmation("Please select a data source");
      setIsConfirmation(true);
    }

  };
  const handleDataSource = (id, name = "") => {
    getDataSourceByRegulation(id, name);
  };

  const callbackBreadCrumb = (index, fId) => {
    let data = [...currentDs];
    let parent = index > 1 ? data[index - 1].id : "";
    setParentId(parent);
    data.length = index + 1;
    setCurrentDs(data);
    getDataSourceByRegulation(fId);
  };

  const handleSelSource = (id) => {
    setSelDataSource(id);
  };

  const callbackModal = (boolVal) => {
    setIsConfirmation(false);
  };

  const rules = () => {
    navigate("/company_admin/document_rules/" + regulationId);
  }
  const LinktodatasourceHelpText = (
    <Tooltip id="Risk_help_test">
      {t("DataLinkedLocationAutomaticallyApplicationToolTip.label")}
    </Tooltip>
  );

  return (
    <>
      <div className="LinkDataSource_card">
        {isConfirmation && <ConfirmationModal modalShow={true} messageText={messageConfirmation} callbackModal={callbackModal} />}
        <div className="LinkDataSource_card_head">
          <h6>
            {t("Linktodatasource.label")}
            <OverlayTrigger
              placement="bottom"
              overlay={LinktodatasourceHelpText}
            >
              <span className="ms-2  text-dark"><BsQuestionCircle /></span>
            </OverlayTrigger>
          </h6>
        </div>
        {rootList.length > 0
          ? rootList?.map((item, index) => (
            <div className="card RSW_Add_Card" key={item.id} id={item.id}>
              <div className="card-body p-0">
                <div className="RSW_Add_Card_row01">
                  <div className="expand_RswBox 1">
                    {item.children?.length > 0 && (
                      <BiChevronDown
                        onClick={(e) => handleExpandDs(e, item.id, item.name)}
                        aria-controls="example-collapse-text"
                        aria-expanded={shown[item.id]}
                      ></BiChevronDown>
                    )}
                  </div>

                  <div className="row m-0">
                    <div className="col-lg-10 p-1">
                      <div className="row m-0 RSW_Add_Card_head 2">
                        <div className="col-lg-10 p-0">
                          {currentDs?.length > 0 && currentDs[0].id === item.id
                            ? currentDs.length <= 1
                              ? item.name
                              : currentDs[0].id === item.id && (
                                <DsBreadcrumbs
                                  currentList={currentDs}
                                  callbackBreadCrumb={callbackBreadCrumb}
                                />
                              )
                            : item.name}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 p-1 13">
                      {item.assignable && (
                        <div className="d-flex align-items-center justify-content-center">
                          <input
                            type="radio"
                            value={item.id}
                            name="datasource"
                            id={`datasource_select_${item.id}`}
                            defaultChecked={selDataSource === item.id}
                            onClick={(e) => handleSelSource(item.id)}
                          />
                          <label className="form-check-label ms-1" htmlFor={`datasource_select_${item.id}`}>
                            Select
                          </label>
                        </div>

                      )}
                      {item.dataSourceType === 'DOCUMENT' &&
                        <div onClick={() => rules()}><a className="cursor">{t("AddEditRules.label")}</a></div>}

                    </div>
                    <Collapse in={shown[item.id]}>
                      <div className="col-lg-12 p-1">
                        {dsList.length > 0 ? (
                          <LinkDataItems
                            list={dsList}
                            handleDataSource={handleDataSource}
                            handleSelSource={handleSelSource}
                            dsId={dsId}
                          />
                        ) : (

                          <div className="Nodatafound_box">
                            <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                          </div>

                        )}
                      </div>
                    </Collapse>
                  </div>
                </div>
              </div>
            </div>
          ))
          : <div className="Nodatafound_box">
            <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
          </div>}
        <div className="row m-0">
          <div className="col-lg-12 p-2 tableView_button_container">
            <button
              className="btn btn-secondary me-2 px-3"
              onClick={closeLinkDataSource}
            >
              {" "}
              {t("Discard.label")}
            </button>
            <button className="btn btn-primary sbmBtn px-4" onClick={saveDataSource}>
              {" "}
              {t("Save.label")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
LinkDataSource.propTypes = {};
export default withTranslation()(LinkDataSource);
